import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { Content, Container, Form, Footer } from '@atoms/AdminForm';
import { permissions, defaultPermission } from '@config/authentication';
import { Button } from '@atoms';
import { ResetPassword } from '@molecules';
import messages from './messages';

export default class EditUser extends Component {
  static propTypes = {
    userId: PropTypes.number.isRequired,
    selectedPermission: PropTypes.oneOf(permissions),
    isSaving: PropTypes.bool,
    name: PropTypes.string.isRequired,
    save: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isSaving: false,
    selectedPermission: defaultPermission,
    name: 'editUser',
  };

  save = () => this.props.save(this.props.userId);
  cancel = () => this.props.cancel();
  onChange = (evt, value) => this.props.onChange(value);

  render() {
    return (
      <Container id="edit-user">
        <Content>
          <h2>
            <FormattedMessage {...messages.resetPasswordTitle} />
          </h2>
          <ResetPassword userId={this.props.userId} />
        </Content>
        <Form>
          <Content>
            <h2>
              <FormattedMessage {...messages.radioGroupTitle} />
            </h2>
            <RadioButtonGroup
              name={this.props.name}
              valueSelected={this.props.selectedPermission}
              onChange={this.onChange}
            >
              {permissions.map((permission) => (
                <RadioButton
                  key={permission}
                  value={permission}
                  label={<FormattedMessage {...messages.radio[permission]} />}
                />
              ))}
            </RadioButtonGroup>
          </Content>
          <Footer>
            <Button secondary small onClick={this.cancel} disabled={this.props.isSaving}>
              <FormattedMessage {...messages.inputCancel} />
            </Button>
            <Button primary small loading={this.props.isSaving} onClick={this.save}>
              <FormattedMessage {...messages.inputSave} />
            </Button>
          </Footer>
        </Form>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./components/organisms/EditUser/EditUser.component.js